export default __webpack_public_path__ + "static/media/chevron-left-white.5b4ed4c0.svg";